// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max'

/** 修改密码 POST /user/changePassword */
export async function changePassword(body: API.ChangePasswordForm, options?: { [key: string]: any }) {
    return request<API.BaseResponseLong>('/user/changePassword', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}

/** 用户反馈 POST /user/feedback */
export async function feedback(body: API.FeedbackForm, options?: { [key: string]: any }) {
    return request<API.BaseResponseBoolean>('/user/feedback', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}

/** 退出登录 GET /user/logout */
export async function logout(options?: { [key: string]: any }) {
    return request<API.BaseResponseBoolean>('/user/logout', {
        method: 'GET',
        ...(options || {}),
    })
}

/** 检查重置密码链接是否有效 GET /user/public/checkResetLink/${param0} */
export async function checkResetLink(
    // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
    params: API.checkResetLinkParams,
    options?: { [key: string]: any },
) {
    const { link: param0, ...queryParams } = params
    return request<API.BaseResponseLong>(`/user/public/checkResetLink/${param0}`, {
        method: 'GET',
        params: { ...queryParams },
        ...(options || {}),
    })
}

/** 邮箱注册并登录（已废弃，请使用 /user/public/login） POST /user/public/email/login */
export async function loginByEmail(body: API.LoginByEmailForm, options?: { [key: string]: any }) {
    return request<API.BaseResponseLoginVO>('/user/public/email/login', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}

/** 邮箱发送验证码 POST /user/public/email/sendCode */
export async function sendCodeByEmail(body: API.SendEmailCodeForm, options?: { [key: string]: any }) {
    return request<API.BaseResponseBoolean>('/user/public/email/sendCode', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}

/** 统一登录接口 支持手机验证码、密码、邮箱验证码三种登录方式 POST /user/public/login */
export async function unifiedLogin(body: API.UnifiedLoginRequest, options?: { [key: string]: any }) {
    return request<API.BaseResponseLoginVO>('/user/public/login', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}

/** 密码登录（已废弃，请使用 /user/public/login） POST /user/public/password/login */
export async function loginByPassword(body: API.LoginByPasswordForm, options?: { [key: string]: any }) {
    return request<API.BaseResponseLoginVO>('/user/public/password/login', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}

/** 手机验证码登录（已废弃，请使用 /user/public/login） POST /user/public/phoneLogin */
export async function phoneLogin(body: API.LoginByPhoneForm, options?: { [key: string]: any }) {
    return request<API.BaseResponseLoginVO>('/user/public/phoneLogin', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}

/** 统一注册接口 支持手机、邮箱两种注册方式，注册成功后自动登录 POST /user/public/register */
export async function unifiedRegister(body: API.UnifiedRegisterRequest, options?: { [key: string]: any }) {
    return request<API.BaseResponseLoginVO>('/user/public/register', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}

/** 重置密码 POST /user/public/resetPassword/${param0} */
export async function linkResetPassword(
    // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
    params: API.linkResetPasswordParams,
    body: API.ResetPasswordForm,
    options?: { [key: string]: any },
) {
    const { link: param0, ...queryParams } = params
    return request<API.BaseResponseLong>(`/user/public/resetPassword/${param0}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        params: { ...queryParams },
        data: body,
        ...(options || {}),
    })
}

/** 请求发送重置密码链接 GET /user/public/resetPassword/${param0} */
export async function requestResetLink(
    // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
    params: API.requestResetLinkParams,
    options?: { [key: string]: any },
) {
    const { email: param0, ...queryParams } = params
    return request<API.BaseResponseLong>(`/user/public/resetPassword/${param0}`, {
        method: 'GET',
        params: { ...queryParams },
        ...(options || {}),
    })
}

/** 发送手机验证码 POST /user/public/sendPhoneCode */
export async function sendPhoneCode(body: API.SendPhoneCodeForm, options?: { [key: string]: any }) {
    return request<API.BaseResponseBoolean>('/user/public/sendPhoneCode', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}

/** 发送手机登录验证码 POST /user/public/sendPhoneLoginCode */
export async function sendPhoneLoginCode(body: API.SendPhoneCodeForm, options?: { [key: string]: any }) {
    return request<API.BaseResponseBoolean>('/user/public/sendPhoneLoginCode', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}

/** 初次登录设置密码 POST /user/setPassword */
export async function setPassword(body: API.SetPasswordForm, options?: { [key: string]: any }) {
    return request<API.BaseResponseLong>('/user/setPassword', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}
